import { provideHooks } from "redial";
import { fetchSearch } from "../../state/modules/search";
import { getIsNewSearch } from "../../state/modules/search/selectors";
import SearchPage from "../../components/SearchPage";

const isValidSearch = location => location?.query?.q?.trim().length > 0;

export const hooks = {
  fetch: ({ dispatch, location, store, uuid, xSiteOrigin }) => {
    if (isValidSearch(location)) {
      if (!getIsNewSearch(store.getState())) {
        return;
      }

      return dispatch(fetchSearch(uuid, xSiteOrigin));
    }
  }
};

export default provideHooks(hooks)(SearchPage);
